import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/web-global/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-select-microphone',
  templateUrl: './help-select-microphone.component.html',
  styleUrls: ['./help-select-microphone.component.scss']
})
export class HelpSelectMicrophoneComponent implements ContentModel {
  static ref = HelpModel.MICROPHONE;
  static title = 'Setup microphone';

  showBackHeader = true;

  helpTitle = HelpSelectMicrophoneComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    // console.log(this.onModalClose()) **shows zero observers**   :-(
    this.modalClose.next();
    this.modalClose.complete();
  }
}
